import type { AppMessages } from '../../types';

export const app: AppMessages = {
  common: {
    loading: 'A carregar...',
    saving: 'A guardar...',
    save: 'Guardar',
    back: 'Voltar',
    error: 'Erro',
    notSet: 'Não definido',
    user: 'Utilizador',
    system: 'Sistema',
    copied: 'Copiado!',
    copy: 'Copiar',
    cancel: 'Cancelar',
    creating: 'A criar...',
    processing: 'A processar...',
    you: 'Tu',
    stars: 'Stars',
    seeAll: 'Ver tudo',
    filter: 'Filtrar',
    amount: 'Montante',
    date: 'Data',
    details: 'Detalhes',
    mustBeLoggedIn: 'Tem de iniciar sessão',
    daysShort: 'd',
    hoursShort: 'h',
    minutesShort: 'min',
    justNow: 'Agora mesmo',
    noTitle: 'Sem título',
    payment: 'pagamento',
    payments: 'pagamentos',
  },
  layout: {
    dashboard: 'Painel',
    invoices: 'Faturas',
    ledger: 'Livro-razão',
    withdraws: 'Levantamentos',
    redirects: 'Redirecionamentos',
    settings: 'Definições',
    admin: 'Admin',
    profile: 'Perfil',
    logout: 'Terminar sessão',
    tonConfigured: 'TON configurado',
    configureTon: 'Configurar TON',
    tonNotConfigured: 'Endereço TON não configurado',
    active: 'Ativo',
    walletConnect: 'Conectar wallet',
    walletTitle: 'Conecte a sua wallet TON',
    walletSubtitle: 'Introduza o endereço TON que receberá os seus levantamentos.',
    walletConnectedTitle: 'Wallet conectada',
    walletConnectedSubtitle: 'Os seus levantamentos serão enviados para este endereço.',
    walletCurrentAddress: 'Endereço conectado',
    walletAddressLabel: 'Endereço TON',
    walletHint: 'Formato user-friendly (EQ… / UQ…) ou raw (0:…) aceite.',
    walletInvalidAddress: 'Endereço TON inválido',
    walletUpdate: 'Atualizar endereço',
    walletChangeAddress: 'Alterar endereço',
    walletDisconnect: 'Desconectar',
    walletDisconnectConfirmTitle: 'Desconectar a wallet?',
    walletDisconnectConfirmBody: 'Não poderá pedir levantamentos até conectar um novo endereço.',
    walletSaved: 'Wallet conectada com sucesso',
    walletDisconnected: 'Wallet desconectada',
    newPaymentLink: 'Nova ligação de pagamento',
    openBot: 'Bot do Telegram',
    helpCenter: 'Centro de ajuda',
  },
  login: {
    seoTitle: 'Iniciar sessão | Plataforma de pagamentos Telegram Stars',
    seoDescription: 'Inicie sessão na sua conta Telegram Stars Payment Platform',
    signIn: 'Iniciar sessão',
    signUp: 'Registar',
    email: 'E-mail',
    password: 'Palavra-passe',
    displayNameOptional: 'Nome a exibir (opcional)',
    displayNamePlaceholder: 'O seu nome',
    emailPlaceholder: 'seu@email.com',
    signInButton: 'Iniciar sessão',
    signUpButton: 'Registar',
    signInWithGoogle: 'Iniciar sessão com Google',
    or: 'OU',
    welcome: 'Bem-vindo',
    subtitle: 'Inicie sessão ou crie uma conta para começar',
    minPasswordHint: 'Mínimo 6 caracteres',
    tipTelegram: '💡 Dica: pode associar a sua conta Telegram nas definições após o registo',
    continueWithTelegram: 'Continuar com o Telegram',
    telegramAuthError: 'Falha no início de sessão com o Telegram. Tente novamente.',
    featureInstant: 'Criação instantânea de conta',
    featureManage: 'Gerir os seus pagamentos Telegram Stars',
    featureWithdraw: 'Levantar os seus fundos para TON',
    emailRequired: 'Introduza o seu e-mail',
    emailInvalid: 'Formato de e-mail inválido',
    passwordRequired: 'Introduza a sua palavra-passe',
    passwordRequiredSignup: 'Introduza uma palavra-passe',
    passwordMinLength: 'A palavra-passe deve conter pelo menos 6 caracteres',
    genericError: 'Ocorreu um erro',
    recaptchaFailed: 'Verificação reCAPTCHA falhou. Tente novamente.',
    invalidCredentials: 'E-mail ou palavra-passe incorretos. Se ainda não tem conta, crie uma no separador «Registar».',
    wrongPassword: 'Palavra-passe incorreta. Verifique a palavra-passe.',
    tooManyAttempts: 'Demasiadas tentativas. Tente novamente mais tarde.',
    accountDisabled: 'Esta conta foi desativada. Contacte o suporte.',
    authNotEnabled: 'A autenticação por e-mail/palavra-passe não está ativa. Verifique a configuração Firebase.',
    emailInUse: 'Este e-mail já está em uso. Inicie sessão com este e-mail.',
    googleAuthError: 'Ocorreu um erro durante a autenticação Google',
    popupClosed: 'A janela popup foi fechada. Tente novamente.',
    popupBlocked: 'A janela popup foi bloqueada. Permita popups e tente novamente.',
    popupCancelled: 'Apenas um pedido popup é permitido de cada vez.',
  },
  dashboard: {
    loading: 'A carregar painel...',
    overallSummary: 'Resumo geral',
    lastMonth: 'Mês passado',
    lastWeek: 'Semana passada',
    lastYear: 'Ano passado',
    balance: 'Saldo',
    available: 'Disponível',
    totalEarned: 'Total ganho',
    fromLastMonth: 'em relação ao mês passado',
    recentPayments: 'Pagamentos recentes',
    last7days: 'Últimos 7 dias',
    last30days: 'Últimos 30 dias',
    quickActions: 'Ações rápidas',
    createLink: 'Criar ligação',
    createLinkDesc: 'Gerar uma nova ligação de pagamento',
    withdraw: 'Levantar',
    withdrawDesc: 'Levantar Stars para TON',
    invoices: 'Faturas',
    invoicesDesc: 'Ver histórico de pagamentos',
    ledger: 'Livro-razão',
    ledgerDesc: 'Ver todas as transações',
    recentActivity: 'Atividade recente',
    noRecentActivity: 'Sem atividade recente',
    mostRecent: 'Mais recentes',
    noRecentInvoices: 'Sem faturas recentes',
    allInvoices: 'Todas as faturas',
    paymentReceived: 'Pagamento recebido: {title}',
    withdrawalRequested: 'Levantamento solicitado: {amount} {suffix}',
    transaction: 'Transação: {amount} {suffix}',
    invoiceLabel: 'Fatura #{id}',
    failedLoadBalance: 'Falha ao carregar saldo',
    chartAmount: 'Montante',
  },
  invoices: {
    loading: 'A carregar...',
    allInvoices: 'Todas as faturas',
    paid: 'Pagas',
    sent: 'Enviadas',
    created: 'Criadas',
    expired: 'Expiradas',
    filter: 'Filtrar',
    createInvoice: '+ Criar fatura',
    noInvoices: 'Nenhuma fatura encontrada',
    relatedTo: 'Relacionado com:',
    paymentMode: 'Pagamento {mode}',
    copyLink: 'Copiar ligação',
    copyLinkTitle: 'Copiar ligação da fatura',
    linkNotAvailable: 'Ligação da fatura indisponível',
    linkCopied: 'Ligação da fatura copiada para a área de transferência!',
    copyFailed: 'Falha ao copiar ligação',
    failedLoad: 'Falha ao carregar faturas',
    statusPaid: 'paga',
    statusSent: 'enviada',
    statusCreated: 'criada',
    statusExpired: 'expirada',
    typeSingleUse: 'uso único',
    typeRecurring: 'recorrente',
  },
  createInvoice: {
    back: 'Voltar',
    title: 'Criar uma ligação de pagamento',
    subtitle: 'Gere uma nova ligação de pagamento em segundos',
    successTitle: 'Ligação de pagamento criada!',
    successSubtitle: 'A sua ligação de pagamento está pronta para partilhar',
    paymentLink: 'Ligação de pagamento:',
    integrationTitle: 'Integrar esta ligação no seu site',
    integrationDesc: 'O nosso bot Telegram guia-o passo a passo (API, botão HTML, redirecionamentos).',
    openTutorial: 'Abrir tutorial',
    testLink: 'Testar ligação',
    viewInvoices: 'Ver as minhas faturas',
    createNew: 'Criar uma nova ligação',
    shareTelegram: 'Partilhar no Telegram',
    paymentMode: 'Modo de pagamento',
    modeStars: 'Stars',
    modeEur: 'EUR (€)',
    modeUsd: 'USD ($)',
    amountInteger: 'Montante (inteiro)',
    amountDecimal: 'Montante (decimal)',
    amountRequired: 'Introduza um montante',
    amountIntegerError: 'O montante deve ser um inteiro superior a 0',
    amountNoDecimals: 'O montante em Stars deve ser um inteiro (sem decimais)',
    amountMustBeInteger: 'O montante em Stars deve ser um inteiro',
    amountGreaterThanZero: 'O montante deve ser superior a 0',
    titleOptional: 'Título (opcional)',
    titlePlaceholder: 'Título do pagamento (ex.: Pagamento de serviços)',
    descriptionOptional: 'Descrição (opcional)',
    descriptionPlaceholder: 'Descrição detalhada do pagamento...',
    singleUse: 'Ligação de uso único',
    singleUseTooltip: 'Se ativado, esta ligação só pode ser usada uma vez. Após o pagamento, deixará de ser válida.',
    createLink: 'Criar ligação',
    cancel: 'Cancelar',
    invalidAmount: 'Montante inválido',
    starsMustBeInteger: 'O montante deve ser um inteiro para Stars',
    createError: 'Erro ao criar fatura',
  },
  ledger: {
    title: 'Livro-razão',
    typeColumn: 'Tipo',
    description: 'Histórico completo de todas as suas transações',
    loading: 'A carregar...',
    noEntries: 'Sem transações de momento.',
    typePayment: 'Pagamento',
    typeFee: 'Taxa',
    typeNetPayment: 'Pagamento líquido',
    typeWithdrawal: 'Levantamento',
    typeAdjustment: 'Ajuste',
    amountStars: 'Montante (Stars)',
    invoiceDetail: 'Fatura: {title} ({amount} Stars)',
    paidBy: 'Pago por: {payer}',
    payerId: '(ID: {id})',
    withdrawDetail: 'Levantamento: {amount} Stars (Estado: {status})',
    failedLoad: 'Falha ao carregar livro-razão',
  },
  withdraws: {
    title: 'Os meus pedidos de levantamento',
    newRequest: '+ Novo pedido',
    totalLedger: 'Total livro-razão',
    available: 'Disponível',
    pendingWithdrawals: 'Levantamentos pendentes',
    hold21days: 'Retenção 21 dias',
    payoutNote: 'Os pagamentos são processados manualmente por um admin. Aplica-se uma taxa de 3% no levantamento.',
    forecastTitle: 'Previsão de levantamentos',
    loadingForecast: 'A carregar previsão...',
    noForecast: 'Sem datas de levantamento próximas',
    paymentsCount: '({count} pagamentos)',
    noRequests: 'Sem pedidos de levantamento de momento.',
    createFirst: 'Crie o seu primeiro pedido',
    amount: 'Montante:',
    destination: 'Destino:',
    processedOn: 'Processado em:',
    externalRef: 'Referência externa:',
    errorLabel: 'Erro:',
    rejectionReason: 'Motivo de rejeição:',
    failedLoad: 'Falha ao carregar levantamentos',
    loading: 'A carregar...',
  },
  createWithdraw: {
    title: 'Solicitar um levantamento',
    balanceSource: 'Saldo (fonte: livro-razão backend)',
    available: 'Disponível: {amount} Stars',
    pending: 'Levantamentos pendentes: {amount} Stars',
    waiting: 'Retenção 21 dias: {amount} Stars',
    minAndFee: 'Levantamento mínimo: {min} Stars · Taxa da plataforma: 3% no pagamento (processamento manual)',
    amountLabel: 'Montante (Stars)',
    minPlaceholder: 'Mínimo: {min}',
    feeHint: 'Bruto: {gross} Stars · Taxa (3%): {fee} Stars · Recebe: {net} Stars',
    useRegistered: 'Usar o meu endereço TON registado',
    registeredAddress: 'Endereço registado:',
    tonDestination: 'Endereço de destino TON',
    tonPlaceholder: 'EQAbc123...',
    tonFormatHint: 'Formato: EQ... ou 0:... (base64 ou hex)',
    createRequest: 'Criar pedido',
    cancel: 'Cancelar',
    creating: 'A criar...',
    insufficientBalance: '⚠️ Saldo insuficiente para levantamento (mínimo: {min} Stars)',
    amountMustBeInteger: 'O montante deve ser um inteiro positivo',
    createError: 'Erro ao criar pedido de levantamento',
  },
  redirects: {
    title: 'Ligações de redirecionamento',
    description: 'Crie ligações curtas que redirecionam para um URL à sua escolha. Partilhar a ligação /r/o-seu-slug enviará os visitantes para o URL configurado.',
    newRedirect: 'Novo redirecionamento',
    clicks: 'cliques',
    unique: 'únicos',
    links: 'ligações',
    modalTitle: 'Novo redirecionamento',
    slugLabel: 'Slug (identificador da ligação)',
    slugRequired: 'Campo obrigatório',
    slugPattern: 'Apenas letras, números, hífens e underscores',
    slugMax: 'Máx. 64 caracteres',
    slugReserved: 'Este slug está reservado. Escolha outro.',
    slugPlaceholder: 'ex.: o-meu-site',
    urlLabel: 'URL de destino',
    urlInvalid: 'URL inválido',
    urlHttpOnly: 'Apenas URLs http e https são aceites.',
    urlTooLong: 'URL demasiado longo (máx. 2048 caracteres).',
    urlPlaceholder: 'https://example.com/page',
    createButton: 'Criar redirecionamento',
    loading: 'A carregar…',
    empty: 'Sem redirecionamentos. Clique em «Novo redirecionamento» para criar um.',
    copyLink: 'Copiar ligação',
    linkCopied: 'Ligação copiada',
    deleteTitle: 'Eliminar este redirecionamento?',
    yes: 'Sim',
    no: 'Não',
    delete: 'Eliminar',
    totalClicks: 'Total de cliques',
    uniqueClicks: 'Cliques únicos',
    avgClicks: 'Méd. cliques/visitante',
    loadError: 'Erro ao carregar redirecionamentos',
    createSuccess: 'Ligação de redirecionamento criada',
    createError: 'Erro ao criar redirecionamento',
    deleteSuccess: 'Redirecionamento eliminado',
    deleteError: 'Erro ao eliminar redirecionamento',
  },
  adminWithdraws: {
    title: 'Administração - Pedidos de levantamento',
    filterByStatus: 'Filtrar por estado:',
    all: 'Todos',
    noRequests: 'Sem pedidos para este estado.',
    agent: 'Agente:',
    amount: 'Montante:',
    destination: 'Destino:',
    processedOn: 'Processado em:',
    externalRef: 'Ref. externa:',
    errorLabel: 'Erro:',
    reason: 'Motivo:',
    approve: '✓ Aprovar',
    reject: '✗ Rejeitar',
    markPaid: '✓ Marcar pago',
    markFailed: '✗ Marcar falhado',
    approveConfirm: 'Aprovar este pedido de levantamento?',
    rejectPrompt: 'Motivo de rejeição:',
    markPaidPrompt: 'Referência de pagamento externa (obrigatória — hash tx TON, ref. bancária, etc.):',
    markPaidRequired: 'externalRef é obrigatório para confirmar um pagamento manual.',
    markFailedPrompt: 'Mensagem de erro:',
    approveError: 'Erro ao aprovar levantamento',
    rejectError: 'Erro ao rejeitar levantamento',
    updateError: 'Erro ao atualizar',
    failedLoad: 'Falha ao carregar levantamentos',
    notAuthenticated: 'Não autenticado',
    operationFailed: 'Operação falhou',
    loading: 'A carregar...',
  },
  redirectResolve: {
    missingSlug: 'Slug em falta',
    invalidLink: 'Ligação inválida',
    notFound: 'Ligação não encontrada',
    notFoundTitle: 'Ligação não encontrada',
    redirecting: 'A redirecionar...',
    redirectTitle: 'Redirecionamento',
  },
  errorBoundary: {
    title: 'Ocorreu um erro',
    subtitle: 'Desculpe, algo correu mal. Tente novamente.',
    goHome: 'Voltar ao início',
    reload: 'Recarregar página',
    devDetails: 'Detalhes do erro (apenas dev):',
  },
};

export const settingsApp = {
  eyebrow: 'DEFINIÇÕES',
  profile: 'Perfil',
  email: 'E-mail',
  telegramId: 'ID Telegram',
  notLinked: 'Não associado',
  linking: 'A associar...',
  linkTelegram: 'Associar a minha conta Telegram',
  openFromTelegram: '⚠️ Abra esta página a partir do Telegram para associar a sua conta',
  displayName: 'Nome a exibir',
  displayNameHint: 'O nome a exibir é definido na criação da conta',
  withdrawal: 'Levantamento',
  tonAddress: 'Endereço de destino TON',
  tonAddressPlaceholder: 'EQAbc123... ou 0:...',
  tonAddressHint: 'Este endereço será usado por defeito para os seus levantamentos',
  tonUpdated: 'Endereço TON atualizado com sucesso',
  about: 'Sobre',
  commission: 'Comissão da plataforma:',
  commissionValue: '3% em cada pagamento',
  minWithdrawal: 'Levantamento mínimo:',
  minWithdrawalValue: '100 Stars',
  starsCurrency: 'Moeda Stars:',
  starsCurrencyValue: 'XTR',
  telegramWebAppNotAvailable: 'Telegram WebApp indisponível. Abra esta página a partir do Telegram.',
  telegramUserDataNotAvailable: 'Dados de utilizador Telegram indisponíveis.',
  telegramLinked: 'Conta Telegram associada com sucesso!',
  linkTelegramError: 'Erro ao associar conta Telegram',
  updateError: 'Erro ao atualizar',
  mustBeLoggedIn: 'Tem de iniciar sessão',
};
